if (typeof customElements !== 'undefined' && !customElements.get('sf-filter')) {
  customElements.define('sf-filter', class extends HTMLElement {
    connectedCallback() {
      this.chips = [...this.querySelectorAll('[data-filter]')];
      this.cards = [...this.querySelectorAll('[data-niche]')];
      this.chips.forEach((chip) => chip.addEventListener('click', () => this.apply(chip)));
    }

    apply(active) {
      const value = active.dataset.filter;
      this.chips.forEach((chip) => {
        const on = chip === active;
        chip.classList.toggle('is-active', on);
        chip.setAttribute('aria-pressed', String(on));
      });
      this.cards.forEach((card) => {
        const show = value === 'alle' || card.dataset.niche === value;
        card.hidden = !show;
        if (show) card.classList.add('is-visible');
      });
    }
  });
}
